import React, { useRef, useEffect } from 'react';
import { primary } from "../../theme/colors"
import mapboxgl from 'mapbox-gl';
import './Location.css'


mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

const Location = (props) => {

    const {coordsMap} = props

    const mapContainerRef = useRef(null);

    useEffect(() => {
        const map = new mapboxgl.Map({
            container: mapContainerRef.current,
            style: 'mapbox://styles/mapbox/outdoors-v11', // estilo do mapa
            center: [-53.5738718447763, -9.98163927009899], // [longitude, latitude] -3.052387892718202, -60.018676030494284
            zoom: 3,
        });

        coordsMap.map((coord) => {

                new mapboxgl.Marker({ color: `${primary.primary300}` })
                .setLngLat(coord.coords)
                .setPopup(
                    new mapboxgl.Popup({ offset:25 }).setHTML(`<h>${coord.cardTitle}</h4>`)
                )
                .addTo(map)

        })

        return ()=> map.remove()
    }, [coordsMap]);

    return (
        <div className="map-store"
            ref={mapContainerRef}
        />
    );
};


export default Location;